<header>
    <div class="topbar">
        <div class="topbar-left"></div>
        <div class="topbar-middle"></div>
        <div class="topbar-right"></div>
    </div>
    <nav class="navbar navbar-expand-lg bg-light">
        <div class="container-fluid">
            <a class="navbar-brand" routerLink="/{{global.culture}}/home">
                <img src="assets/images/logo-evok.png" class="img-fluid d-none d-md-block" alt="EVOK Performance">
                <img src="assets/images/logo-evok.png" class="img-fluid d-block d-md-none" alt="EVOK Performance">
            </a>
            <button id="buttonMenuMobile" class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarNav">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0" >        
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                            {{'prodotti' | translate | uppercase}}
                        </a>
                        <ul class="dropdown-menu" style="margin-top: 0;">
                        <li *ngFor="let voce of vociMenu" class="nav-item dropdown dropend">
                            <a routerLink="/{{global.culture}}/category-list/K{{voce.comparto.key}}/{{cleanUp(voce.comparto.value)}}" (click)="closeMenu()" class="nav-link dropdown-item">
                                {{voce.comparto.value | uppercase}}
                            </a>
                        </li>
                        </ul>
                    </li>             
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/{{global.culture}}/search-application" (click)="closeMenu()"> {{'application.ricercaVeicolo'| translate}}</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/{{global.culture}}/about-us" (click)="closeMenu()">{{'chiSiamo'| translate}}</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/{{global.culture}}/download/catalog" (click)="closeMenu()">{{'cataloghi' | translate | uppercase}}</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" routerLink="/{{global.culture}}/download/instructions" (click)="closeMenu()">{{'istruzioni' | translate | uppercase}}</a>
                    </li>
                </ul>
                <div id="searchbar" class="d-flex" role="search">
                    <input class="search__input" type="search" placeholder="{{'ricercaLiberaOCodice' | translate}}" (keydown.enter)="onSearchComplete()"  [(ngModel)]="keyword">
                </div>                                
              
                <div ngbDropdown class="btn-group dropleft" style="margin-right:1rem; padding-left: 10px;">
                    <a href="https://www.instagram.com/evok_performance/" class="indicator__button" target="_blank" style="margin-top: 1px;" rel="nofollow">
                        <div class="logo__image">
                            <fa-icon [icon]="faInstagram" [styles]="{ height: '27px', width: '27px'}"></fa-icon>
                        </div>
                    </a>
                </div>
                <div ngbDropdown class="btn-group dropleft" style="margin-right:1rem; padding-left: 10px;">
                    <a href="https://www.facebook.com/profile.php?id=61560960101822" class="indicator__button" target="_blank" style="margin-top: 1px;" rel="nofollow">
                        <div class="logo__image">
                            <fa-icon [icon]="faFacebook" [styles]="{ height: '27px', width: '27px'}"></fa-icon>
                        </div>
                    </a>
                </div>
                <div ngbDropdown class="btn-group dropleft" style="margin-right:1.5%;" >
                    <button ngbDropdownToggle class="btn" type=" dropdown-toggle" id="dropdownMenuLng" aria-expanded="false">
                        <img src="../../../../assets/images/languages/lang-{{global.culture}}.png">
                    </button>
                    <div class="dropdown-menu" >
                        <ul ngbDropdownMenu aria-labelledby="dropdownMenuLng" style="margin-right:1.5%; " class="dropdown-content">
                            <li>
                                <a ngbDropdownItem href="/it/home">
                                    <img src="../../../../assets/images/languages/lang-it.png">
                                    {{'italiano' | translate}}
                                </a>
                            </li>
                            <li>
                                <a ngbDropdownItem href="/en/home">
                                    <img src="../../../../assets/images/languages/lang-en.png">
                                    {{'inglese' | translate}}
                                </a>
                            </li>
                            <li>
                                <a ngbDropdownItem href="/es/home">
                                    <img src="../../../../assets/images/languages/lang-es.png">
                                    {{'spagnolo' | translate}}
                                </a>
                            </li>
                            <li>
                                <a ngbDropdownItem href="/fr/home">
                                    <img src="../../../../assets/images/languages/lang-fr.png">
                                    {{'francese' | translate}}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </nav>
    <div class="bottombar">
        <div class="bottombar-left"></div>
        <div class="bottombar-middle"></div>
        <div class="bottombar-right"></div>
    </div>
</header>